/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */
import React, { useContext, useEffect, useState } from "react";
import { Button } from "reactstrap";
import { ThemeContext } from "../../contexts/ThemeContext";
import ErrorBoundary from "../general/ErrorBoundary";
import GeneralNavbar from "../general/GeneralNavbar";
import { PsychometricContext } from "../../contexts/PsychometricContext";
import PsychometricTestNavbar from '../psychometric/PyschometricTestNavbar';
const PsychometricTestSkillsIntro = ({   
  goToNextStep, 
  goToPreviousStep, 
  history, 
  location,
  isOrganization,
  signedID,
  signedFirstName,
  signedLastName,
  signedOrganization,
  signedEmail, 
  ...props
}) => {
  const { theme, fontFamily, colors, fontWeight } = useContext(ThemeContext);
  const {isStudent} = useContext(PsychometricContext);
  const [isLoading, setIsLoading] = useState(false);

  const isIframe = new URLSearchParams(location.search).get('iframe') === 'true';

  useEffect(() => {

 // Validate required parameters based on user type
 if (isOrganization === true) {
  if (!signedOrganization || !signedFirstName || !signedLastName || !signedID) {
    console.log("Redirecting due to missing organization parameters...");
    history.replace("/psychometricSignIn");
    return;
  }
} else {
  if (!signedEmail) {
    console.log("Redirecting due to missing email...");
    history.replace("/psychometricSignIn");
    return;
  }
}
    window.scrollTo(0, 0);
  }, [ signedOrganization, signedEmail, isOrganization, signedFirstName,signedLastName, signedID, history]);

  const handleContinue = (e) => {
    e.preventDefault();
    console.log("Next Page button clicked");
    goToNextStep();
  };

  const handlePrevious = (e) => {
    e.preventDefault();
    console.log("Previous Page button clicked");
    goToPreviousStep();
  };

  return (
    <div style={{ fontFamily: fontFamily.primary }}>
            {isIframe && (
                <ErrorBoundary errorAt="At PsychometricSkillsIntro PsychometricTestNavbar">
                    <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
            {!isIframe && (
                <ErrorBoundary errorAt="At General  PsychometricSkillsIntro GeneralNavbar">
                     <PsychometricTestNavbar signedOrganization={signedOrganization} />
                </ErrorBoundary>
            )}
      <div
        className="progress"
        style={{ height: "10px", marginBottom: "10px" }}
      >
        <div
          className="progress-bar bg-success"
          role="progressbar"
          style={{
            width: "60%",
            background:
              "linear-gradient(to right, #28a745 20%, transparent 20%)",
          }}
          aria-valuenow="20"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div className="row p-3 px-5">
        <h1
          className="col-md-12 col-12 mb-3"
          style={{
            fontWeight: fontWeight.bold,
            fontSize: "1.5rem",
            color: colors.primaryGreenDark,
          }}
        >
          DECODING TALENT LANDSCAPE AND PERSONALITY MAPPING
        </h1>
        <h2
          className="col-md-12 col-12 mb-3"
          style={{
            fontWeight: fontWeight.bold,
            fontSize: "1rem",
            color: colors.primaryGreenDark,
          }}
        >
     {isStudent ? "Building a strong academic culture for success" : "Building a strong workplace culture for success"}
        </h2>

        <div className="col-md-12 col-12 mb-4">
          <h2 style={{ fontWeight: fontWeight.bold, fontSize: "1rem" }}>
            YOUR SKILLS
          </h2>
          <p style={{ fontSize: "0.8rem" }}>
            Skills are your natural talents and the abilities we develop to
            perform a task or job. Knowing what skills, we possess can help us
            in identifying specific industries or organizations where our
            strengths might be a good match for the job. How we feel when using
            these skills is also important. If we enjoy work that requires
            certain skills than we need to look for that opportunities to use
            them. Henceforth, it become apparently important to find what skills
            we possess or needs to be develop. Read each item carefully and
            decide which item describes you as a person. Indicate your responses
            to each item by ticking one of the five numbers to the right of each
            item
          </p>
        </div>

        <div className="col-md-12 col-12 mb-4 d-flex justify-content-between">

        <Button
          id="next-page"
          type="button"
          color="primary"
          disabled={isLoading}
          style={theme.formSubmit}
          onClick={handleContinue}
        >
          {isLoading ? (
            <span className="spinner-border spinner-border-sm mr-1"></span>
          ) : null}
          Next Page
        </Button>
        </div>
      </div>
      <footer style={theme.psychometricTestFooter}>
                Powered by Umang Wellness
            </footer>
    </div>
  );
};

export default PsychometricTestSkillsIntro;
